import { Module } from 'vuex';
import { RootState } from '../store';
import { mutations } from '../mutations/settings-billing.mutations';
import { getters } from '../getters/settings-billing.getters';
import { actions } from '../actions/settings-billing.actions';
import { ICurrency } from '@/types/Currency';
import { IPlan } from '@/types/Plans';
import { EnumPlans } from '@/enums/Plans';
import { getPlans } from '@/common/plans';

export const namespace = 'settingsBilling';

export interface ISettingsBillingState {
  activeUserCount: number;
  billingCurrency: ICurrency;
  chargeBeeState: EnumChargeBeeState;
  contactCount: number;
  documentCount: number;
  endDate: Date;
  entityId: string;
  error: string;
  isLoading: boolean;
  isSaving: boolean;
  paymentDate: Date;
  plan: IPlan;
  plans: IPlan[];
  planType: EnumPlans;
  planTypes: EnumPlans[];
  planCode: string;
  planDescription: string;
  planName: string;
  planTitle: string;
  signedCount: number;
  showConfirmStarterModal: boolean;
  showContactSalesModal: boolean;
  showUpdatePlanModal: boolean;
  smsCount: number;
  smsIncluded: number;
  startDate: Date;
  subscription: ISubscription;
  subscriptionId: string;
  updateDetails: IUpdateDetails;
  upgradeable: boolean;
  userCount: number;
}

export enum EnumChargeBeeState {
  succeeded = 'succeeded',
  failed = 'failed',
}

export interface IUpdateDetails {
  isLoading: boolean;
  taxes: string;
  total: number;
}

export interface IBillingDetails {
  activeUserCount: number;
  billingCurrency: ICurrency;
  contactCount: number;
  documentCount: number;
  endDate: Date;
  entityId: string;
  paymentDate: Date;
  planCode: string;
  planDescription: string;
  planName: string;
  planTitle: string;
  signedCount: number;
  smsCount: number;
  smsIncluded: number;
  startDate: Date;
  subscription: ISubscription;
  subscriptionId: string;
  upgradeable: boolean;
  userCount: number;
}

export interface ISubscription {
  currentTermStart: Date;
  currentTermEnd: Date;
  dueInvoicesCount: number;
  dueSince: Date;
  planQuantity: number;
  status: string;
  totalDues: number;
}

export const state: ISettingsBillingState = {
  activeUserCount: 0,
  billingCurrency: null,
  chargeBeeState: null,
  contactCount: 0,
  documentCount: 0,
  endDate: null,
  entityId: '',
  error: '',
  isLoading: true,
  isSaving: false,
  paymentDate: null,
  plan: getPlans()[0],
  plans: getPlans(),
  planType: EnumPlans.essential,
  planTypes: Object.values(EnumPlans),
  planCode: '',
  planDescription: '',
  planName: '',
  planTitle: '',
  signedCount: 0,
  showConfirmStarterModal: false,
  showContactSalesModal: false,
  showUpdatePlanModal: false,
  smsCount: 0,
  smsIncluded: 0,
  startDate: null,
  subscription: null,
  subscriptionId: '',
  updateDetails: {
    isLoading: false,
    taxes: '',
    total: 0,
  },
  upgradeable: true,
  userCount: 0,
};

const namespaced = true;

export const settingsBilling: Module<ISettingsBillingState, RootState> = {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
